// extracted by mini-css-extract-plugin
module.exports = {"input":"style_input__1k1f5"};